<script>
    import Icon from "mdi-svelte";
    import { randString } from "../../scripts/functions";
    import { getEventsAction } from "../../scripts/utils.js";
    import { current_component } from "svelte/internal";
    const events = getEventsAction(current_component);

    export let path = null;
    export let right = false;
    export let size = "normal";
    export let rounded = false;
    export let style = null;
    export let disabled = false;
    
    let strSize = true;

    let iconSizes = {
        "x-large": "32px",
        large: "28px",
        normal: "24px",
        small: "20px",
        "x-small": "14px",
    };
    $: if (Object.keys(iconSizes).indexOf(size) === -1) {
        if(parseInt(size) > 0){
            strSize = false;
            let r = document.querySelector(':root');
            let delta = size - 24;
            r.style.setProperty("--button-padding", 14 + parseInt(delta / 2) + "px");
            r.style.setProperty("--button-border-radius", 14 + parseInt(delta / 2) + "px");
            r.style.setProperty("--button-font-size", size + "px");
            r.style.setProperty("--button-height", "initial");
            // r.style.setProperty("--border-width", 5 + parseInt(delta / 4) + "px");
        }
        else{
            size = "normal";
        }
    }
    let slot = false;
    let localClass;
    while (true) {
        let tempClass = "button-" + randString(5);
        if (document.getElementsByClassName(tempClass).length === 0) {
            localClass = tempClass;
            break;
        }
    }

    $: slot = $$slots.default ? true : false;

</script>

<style lang="less" global>
    @import "Button.less";
</style>

<div class="{localClass} {$$props.class ? $$props.class: ""} {strSize? size :"custom"}" class:disabled={disabled} class:rounded = {rounded} class:right={right && slot} use:events {style}>
    {#if path}
        {#if strSize}
            <Icon size={iconSizes[size]} {path} />
        {:else}
            <Icon size={size} {path} />
        {/if}
    {/if}
    {#if slot}
        <div class="content">
            <slot />
        </div>
    {/if}
</div>
